import 'utils/polyfills'; // Must be the first import

import { LazyWidgetApp } from 'components/LazyWidgetApp';
import { defaultFeatures } from 'constants/features';
import { WidgetFeature } from 'enums/WidgetFeature';
import { WidgetParameters } from 'interfaces/WidgetParameters';
import React from 'react';
import { Provider } from 'react-redux';
import { configureServices, services } from 'services/container';
import { WidgetService } from 'services/WidgetService';
import { setChatMaximized } from 'state/chat/chat.actions';
import { initParameters, setWebviewAdapter } from 'state/parameters/parameters.actions';
import { initStore } from 'state/widgetStore';
import { ChatStateController } from 'utils/chatState';
import { setNetworkTimeDiff } from 'utils/dateTime';
import { ChatPerfomance, EDtrumPerformanceEvent } from 'utils/dtrum';
import { widgetStore } from 'utils/widgetStore';
import { setUseWebWorkers } from 'utils/worker';

interface WidgetScript extends HTMLScriptElement {
    widget: WidgetService;
}

const widgetScript = document.currentScript as WidgetScript;

widgetScript.widget = services.widget;

ChatPerfomance.setPerf(EDtrumPerformanceEvent.JS, performance.now());

services.widget.onLaunch = (widgetParameters: WidgetParameters) => {
    const { webViewAdapter, ...rest } = widgetParameters;
    setUseWebWorkers(rest.useWebWorkers ?? false);
    ChatPerfomance.init(widgetParameters?.MfPerfomanceDtrum, widgetParameters?.httpClient);

    widgetStore.store = initStore(rest.title);
    widgetStore.store.dispatch(setWebviewAdapter(webViewAdapter ?? null));
    widgetStore.store.dispatch(initParameters(rest));
    widgetStore.store.dispatch(
        setChatMaximized(!(widgetParameters?.displaySettings?.compactModeOnStart ?? true)),
    );

    const widgetElement = (
        <Provider store={widgetStore.store}>
            <LazyWidgetApp />
        </Provider>
    );

    configureServices({
        widgetParameters,
        widgetStore: widgetStore.store,
        widgetElement,
        setNetworkTimeDiff,
    });

    ChatStateController.isPreventClosingEnabled =
        widgetParameters?.overrideFeatures?.PreventClosing ??
        defaultFeatures[WidgetFeature.PreventClosing];

    services.dom.inject();
};
